const queryKeys = {
    single: ["duo"] as const,

    getDuo: (duoId: string) => [...queryKeys.single, duoId] as const,
};

export default queryKeys;
